<script>
import { clone } from 'lodash-es';
import InputField from '~/javascripts/forms/components/input_field.vue';
import { COUNTRIES_TO_HIDE_TAX_ID } from '~/javascripts/constants';
import { FIELD_VALIDATIONS } from '~/javascripts/forms/validation/constants';
import { validateObjectPropRequiredFields } from '~/javascripts/lib/object_prop_validator';
import TaxIdHelpIconPopover from '~/javascripts/forms/components/tax_id_help_icon_popover.vue';

const COMPONENT_NAME = 'CompanyDetailsFields';
export default {
  name: COMPONENT_NAME,
  components: {
    TaxIdHelpIconPopover,
    InputField,
  },
  props: {
    initialFormData: {
      type: Object,
      required: true,
      validator(initialFormData) {
        const requiredFields = ['companyName', 'taxId'];
        return validateObjectPropRequiredFields(COMPONENT_NAME, initialFormData, {
          requiredFields,
        });
      },
    },
    showRequiredLabels: {
      type: Boolean,
      required: false,
      default: false,
    },
    selectedCountry: {
      type: String,
      required: false,
      default: null,
    },
  },
  emits: ['change'],
  data() {
    return {
      form: {
        companyName: this.initialFormData.companyName,
        taxId: this.initialFormData.taxId,
      },
    };
  },
  computed: {
    showTaxIdField() {
      return !COUNTRIES_TO_HIDE_TAX_ID.includes(this.selectedCountry);
    },
  },
  mounted() {
    // Triggering this on mount so that the validation can be run on the parent component
    // to determine the initial validation state.
    this.handleFormChange();
  },
  methods: {
    handleFormChange() {
      this.$emit('change', clone(this.form));
    },
  },
  FIELD_VALIDATIONS,
  i18n: {
    companyNameLabel: 'Company name',
    taxIdLabel: 'Tax ID',
    companyNameDescription: 'Company, organization, or team name',
    taxIdDescription: 'VAT, GST, DST, or other tax identification number',
  },
};
</script>

<template>
  <div class="gl-grid gl-grid-cols-2 gl-gap-x-6">
    <input-field
      id="company-name"
      v-model="form.companyName"
      group-class="gl-mb-0"
      :label="__($options.i18n.companyNameLabel)"
      :optional-text="__('required')"
      :optional="showRequiredLabels"
      :label-description="__($options.i18n.companyNameDescription)"
      test-id="company-name"
      rules="required|noEmoji"
      @input="handleFormChange"
    />

    <input-field
      v-if="showTaxIdField"
      id="tax-id"
      v-model="form.taxId"
      group-class="gl-mb-0"
      :label="__($options.i18n.taxIdLabel)"
      :optional="true"
      :label-description="__($options.i18n.taxIdDescription)"
      test-id="tax-id"
      :rules="$options.FIELD_VALIDATIONS.taxId"
      @input="handleFormChange"
    >
      <template #label-help>
        <tax-id-help-icon-popover />
      </template>
    </input-field>
  </div>
</template>
